import { PlanDefinition } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

const checklistTemplatesAdapter = createEntityAdapter({
  selectId: (template: PlanDefinition) => template.id!,
});

interface ChecklistTemplateState {
  entities: ReturnType<typeof checklistTemplatesAdapter.getInitialState>["entities"];
  ids: ReturnType<typeof checklistTemplatesAdapter.getInitialState>["ids"];
  selectedTemplate?: PlanDefinition | undefined | null;
}

const initialState: ChecklistTemplateState = {
  ...checklistTemplatesAdapter.getInitialState(),
  selectedTemplate: null,
};

const reducers = {
  loadTemplates: checklistTemplatesAdapter.setAll,
  createTemplate: checklistTemplatesAdapter.addOne,
  removeTemplate: checklistTemplatesAdapter.removeOne,
  updateTemplate: checklistTemplatesAdapter.updateOne,
  upsertTemplate: checklistTemplatesAdapter.upsertOne,
  setSelectedTemplate: (
    state: ChecklistTemplateState,
    action: PayloadAction<string | undefined | null>,
  ) => {
    state.selectedTemplate = action.payload ? state.entities[action.payload] : null;
  },
};

export const checklistTemplatesSlice = createSlice({
  name: "checklistTemplates",
  initialState,
  reducers,
});

export const {
  loadTemplates,
  createTemplate,
  removeTemplate,
  updateTemplate,
  upsertTemplate,
  setSelectedTemplate,
} = checklistTemplatesSlice.actions;

const selectTemplatesEntities = (state: RootState) => state.checklistTemplates.entities;
export const getSelectedTemplate = (state: RootState) => state.checklistTemplates.selectedTemplate;

export const selectTemplatesList = createSelector(
  [selectTemplatesEntities],
  (templatesEntities): PlanDefinition[] => Object.values(templatesEntities),
);

export const getTemplateById = createSelector(
  [selectTemplatesEntities],
  (templatesEntities) => (templateId: string) => templatesEntities[templateId || ""],
);

export default checklistTemplatesSlice.reducer;
